<picture class="relative block w-full h-96 bg-white -z-10 -mb-72">
  <img
    class="object-cover opacity-30 text-transparent"
    [ngSrc]="campaign?.MainPicture || defaultImg"
    fill
    priority
    [alt]="campaign?.Title"
  />
</picture>
<div class="max-w-6xl mx-auto px-4 z-50">
  <div class="bg-white rounded-3xl overflow-hidden mb-20">
    <mobo-coupon [campaign]="campaign" direction="hor" (redirectToRestaurant)="redirectToRestaurant()"></mobo-coupon>
  </div>
  <div class="w-full flex flex-col lg:flex-row gap-20 mb-10">
    <div class="flex-auto w-full lg:w-1/2 flex flex-col">
      <h4 class="text-justify text-slate-800 text-2xl font-medium mb-6">
        Descrição
      </h4>
      <div
        class="text-justify text-slate-500 text-lg font-normal leading-snug tracking-tight break-words"
      >
        {{ campaign?.Description }}
      </div>
    </div>
    <div class="flex-auto w-full lg:w-1/2 flex flex-col">
      <h4 class="text-justify text-slate-800 text-2xl font-medium mb-6">
        Regras gerais
      </h4>
      <div
        class="text-justify text-slate-500 text-lg font-normal leading-snug tracking-tight break-words"
        *ngFor="let rule of campaign?.Rules"
      >
        {{ rule.Text }}
      </div>
    </div>
  </div>
  <div
    class="w-full h-10 px-4 py-3 bg-slate-100 rounded-lg justify-center items-center gap-1 inline-flex mb-20"
  >
    <div class="w-4 h-4 relative">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5ZM9 11C9 11.1326 8.94732 11.2598 8.85356 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5C8.23479 11.5 7.98043 11.3946 7.7929 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5V8C7.36739 8 7.24022 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24022 7.05268 7.36739 7 7.5 7C7.76522 7 8.01957 7.10536 8.20711 7.29289C8.39465 7.48043 8.5 7.73478 8.5 8V10.5C8.63261 10.5 8.75979 10.5527 8.85356 10.6464C8.94732 10.7402 9 10.8674 9 11ZM7 5.25C7 5.10166 7.04399 4.95666 7.1264 4.83332C7.20881 4.70999 7.32595 4.61386 7.46299 4.55709C7.60003 4.50032 7.75083 4.48547 7.89632 4.51441C8.04181 4.54335 8.17544 4.61478 8.28033 4.71967C8.38522 4.82456 8.45665 4.9582 8.48559 5.10368C8.51453 5.24917 8.49968 5.39997 8.44291 5.53701C8.38615 5.67406 8.29002 5.79119 8.16668 5.8736C8.04334 5.95601 7.89834 6 7.75 6C7.55109 6 7.36032 5.92098 7.21967 5.78033C7.07902 5.63968 7 5.44891 7 5.25Z"
          fill="#64748B"
        />
      </svg>
    </div>
    <div class="text-slate-500 text-sm font-normal leading-none tracking-tight">
      As informações disponíveis são de responsabilidade do estabelecimento.
    </div>
  </div>

  <div class="mb-20">
    <mobo-coupon-list
      *ngIf="restaurant"
      [listTitle]="'OUTRAS OFERTAS DE ' + restaurant?.TradeName"
      [campaigns]="restaurant?.Campaigns"
      (seeAll)="redirectToRestaurant()"
    ></mobo-coupon-list>
  </div>

  <mobo-faq></mobo-faq>
</div>
